import React from 'react';
import moment from 'moment';
import { Text } from '../../../../../CommonComponents/OPL/Text/Text';
import {
  formatCurrency,
  formatNumber,
  formatPercentage,
} from '../../../../../CommonUtils/formatNumber';
import { Cell } from '../../../../hooks/useUnrealizedGainLoss';

const formatValue = (type: string | undefined, value: any) => {
  if (value === null || value === '') {
    return '';
  }

  switch (type) {
    case 'currency':
      return formatCurrency(value, { decimalPlaces: 2 });
    case 'number':
      return formatNumber(value, { decimalPlaces: 2 });
    case 'date':
      return moment(value).format('M/D/YYYY');
    case 'percent':
      return formatPercentage(value / 100, { decimalPlaces: 2 });
    default:
      return value;
  }
};

export const TableCell = ({ type, text: value, align = 'right', fontWeight = 600 }: Cell) => {
  return (
    <Text
      fontWeight={fontWeight}
      textAlign={align}
      variant="tabular"
      width="100%"
      color={
        type === 'currency' && typeof value === 'number' && value < 0 ? 'error.500' : 'neutral.700'
      }
    >
      {formatValue(type, value)}
    </Text>
  );
};
